module.exports = __webpack_public_path__ + "static/wapp-conversacion-2133px-89d409edf5d3d69d8731c3b5c4588c88.gif";